import React from 'react';
import { Loader2, Tag, X } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

export const OrderSummary = ({
  cart,
  pricing,
  appliedDiscount,
  discountCode,
  setDiscountCode,
  discountLoading,
  applyDiscountCode,
  removeDiscount,
}) => (
  <Card className="bg-purple-800/50 border-purple-600 sticky top-24">
    <CardContent className="pt-6">
      <h2 className="text-2xl font-bold text-white mb-6">Order Summary</h2>

      <div className="space-y-3 mb-6 max-h-60 overflow-y-auto">
        {cart.map((item) => (
          <div key={`checkout-${item.id}-${item.size}`} className="flex gap-3">
            <img src={item.image} alt={item.name} className="w-16 h-16 object-cover rounded" />
            <div className="flex-1">
              <p className="text-white text-sm font-semibold">{item.name}</p>
              <p className="text-purple-300 text-xs">{item.size}</p>
              <p className="text-purple-200 text-sm">Qty: {item.quantity}</p>
            </div>
            <p className="text-white font-semibold">${(item.price * item.quantity).toFixed(2)}</p>
          </div>
        ))}
      </div>

      {pricing ? (
        <div className="space-y-3 border-t border-purple-600 pt-4">
          <div className="flex justify-between text-purple-200">
            <span>Subtotal</span>
            <span>${pricing.subtotal.toFixed(2)}</span>
          </div>
          <div className="flex justify-between text-purple-200">
            <span>Shipping</span>
            <span>
              {pricing.shipping === 0 ? (
                <span className="text-green-400">FREE</span>
              ) : (
                `$${pricing.shipping.toFixed(2)}`
              )}
            </span>
          </div>
          <div className="flex justify-between text-purple-200">
            <span>Tax</span>
            <span>${pricing.tax.toFixed(2)}</span>
          </div>

          {appliedDiscount && (
            <div className="flex justify-between text-green-400">
              <span className="flex items-center gap-2">
                <Tag className="w-4 h-4" />
                {appliedDiscount.code}
                <button
                  onClick={removeDiscount}
                  className="text-red-400 hover:text-red-300"
                  data-testid="remove-discount-btn"
                >
                  <X className="w-4 h-4" />
                </button>
              </span>
              <span>-${appliedDiscount.discount_amount.toFixed(2)}</span>
            </div>
          )}

          {!appliedDiscount && (
            <div className="pt-2">
              <div className="flex gap-2">
                <Input
                  type="text"
                  placeholder="Discount code"
                  value={discountCode}
                  onChange={(e) => setDiscountCode(e.target.value)}
                  className="bg-purple-900/50 border-purple-600 text-white placeholder:text-purple-400 text-sm"
                  data-testid="discount-code-input"
                />
                <Button
                  type="button"
                  onClick={applyDiscountCode}
                  disabled={discountLoading}
                  variant="outline"
                  className="border-purple-600 text-purple-200 hover:bg-purple-700 text-sm"
                  data-testid="apply-discount-btn"
                >
                  {discountLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Apply'}
                </Button>
              </div>
            </div>
          )}

          <div className="border-t border-purple-600 pt-3">
            <div className="flex justify-between text-white text-xl font-bold">
              <span>Total</span>
              <span data-testid="order-total">${pricing.total.toFixed(2)}</span>
            </div>
          </div>
        </div>
      ) : (
        <p className="text-purple-300 text-center py-4">Enter shipping address to calculate total</p>
      )}
    </CardContent>
  </Card>
);
